const App = () => {
    return (
        <>
            <p>Companies</p>
        </>
    );
};

export default App;
